<template>
    <div>
        <template>
            <el-alert
                    title="中药汤方"
                    type="info"
                    center
                    :closable="false">
            </el-alert>
        </template>
        <el-collapse accordion>
            <el-collapse-item
                    v-for="(item,index) in foldData"
                    :key="index"
                    :name="index"
                    :title="item.recipeName">
                <el-table :data="item.recipeItemResponses" border :row-class-name="tableRowClassName">
                    <el-table-column type="index" width="auto"></el-table-column>
                    <el-table-column align="center" prop="value" label="药品名称" width="auto"></el-table-column>
                    <el-table-column align="center" label="数量" width="auto">
                        <template slot-scope="scope">
                            <el-input
                                    size="small"
                                    v-model="scope.row.number"
                                    @change="numberchangeAccordion($event,scope.$index,index)"
                                    placeholder="请输入内容"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="recordNumber" label="库存数量" width="auto"></el-table-column>
                    <el-table-column align="center" prop="inventoryWarning" label="库存预警" width="auto"></el-table-column>
                    <el-table-column align="center" prop="unit" label="单位" width="auto"></el-table-column>
                    <el-table-column v-if="priceSwitchVal" align="center" prop="retailPrice" label="单价"
                                     width="auto"></el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button
                                    @click.native.prevent="deleteRows(scope.$index, item.recipeItemResponses,index)"
                                    type="text"
                                    size="small"
                            >移除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="add">
                    <el-autocomplete
                            style="width:100%;"
                            v-model="rowDatas"
                            :fetch-suggestions="querySearchAsync"
                            placeholder="请输入内容"
                            @select="handleSelects"
                            @click.native.prevent="location(index)"
                    ></el-autocomplete>
                </div>

                <!-- 表单 -->
                <el-form :label-position="labelPosition" label-width="130px" style="margin-top:30px;">
                    <el-form-item label="中药汤方名：">
                        <template>
                            <el-select v-model="item.recipeName" placeholder="请选择中药汤方名">
                                <el-option
                                        v-for="item in cfName"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item label="副数：">
                        <el-input-number type="number" :min="1" v-model="item.quantity"></el-input-number>
                    </el-form-item>
                    <el-form-item label="药袋价格：">
                        <el-input-number type="number" :min="1" v-model="item.bagsCost"></el-input-number>
                    </el-form-item>
                    <el-form-item label="系数：">
                        <el-input-number :precision="1" :min="1" v-model="item.coefficient"></el-input-number>
                    </el-form-item>
                    <el-form-item label="煎服法：">
                        <el-input v-model="item.eatType" placeholder="请输入煎服法"></el-input>
                    </el-form-item>
                    <el-form-item label="忌口及日常护理：">
                        <el-input autosize type="textarea" placeholder="请输入忌口及日常护理" v-model="item.note"></el-input>
                    </el-form-item>
                </el-form>
                <div class="inOne-TabBttom">
                    <el-button @click="preserveRemind(index)" type="warning">
                        <i class="fa fa-floppy-o"></i>保存
                    </el-button>
                </div>
            </el-collapse-item>
        </el-collapse>

        <div style="margin-top:15px;"></div>
        <template>
            <el-alert
                    title="新增中药汤方"
                    type="info"
                    center
                    :closable="false">
            </el-alert>
        </template>
        <div class="inOne-advice" style="margin-top:20px;">
            <template>
                <span class="titleText">组方：</span>
                <el-select
                        v-model="noncorresponding.input"
                        filterable
                        placeholder="请选择"
                        @change="selectVariation"
                >
                    <el-option v-for="(item,index) in medicalRecipe" :key="index" :value="item.zufangLogo"></el-option>
                </el-select>
            </template>
            <template>
                <span class="titleText">系数：</span>
                <el-input-number :precision="1" :min="1" v-model="coefficient"></el-input-number>
            </template>
        </div>

        <!-- 列表 -->
        <div class="inOne-table">
            <el-table :data="tableData" border style="width: 100%" :row-class-name="tableRowClassName">
                <el-table-column type="index" width="auto"></el-table-column>
                <el-table-column align="center" prop="value" label="药品名称" width="auto"></el-table-column>
                <el-table-column align="center" label="数量" width="auto">
                    <template slot-scope="scope">
                        <el-input
                                size="small"
                                v-model="scope.row.number"
                                @change="numberchange($event,scope.$index)"
                                placeholder="请输入内容"
                        ></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="recordNumber" label="库存数量" width="auto"></el-table-column>
                <el-table-column align="center" prop="inventoryWarning" label="库存预警" width="auto"></el-table-column>
                <el-table-column align="center" prop="unit" label="单位" width="auto"></el-table-column>
                <el-table-column v-if="priceSwitchVal" align="center" prop="retailPrice" label="单价"
                                 width="auto"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                                @click.native.prevent="deleteRow(scope.$index, tableData)"
                                type="text"
                                size="small"
                        >移除
                        </el-button>
                        <el-button
                                @click="substitute(scope.$index,scope.row)"
                                type="text"
                                size="small"
                        >替换
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 弹出框 -->
            <el-dialog title="药品替换" :visible.sync="dialogFormVisible" width="35%">
                <template>
                    <el-select v-model="val" placeholder="请选择替换的药品" @change="select_Variation">
                        <el-option
                                v-for="(item,index) in cfArr"
                                :key="index"
                                :label="item.value"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </template>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sure">确 定</el-button>
                </div>
            </el-dialog>

            <!-- 组方内新增一味药 -->
            <div class="add">
                <el-autocomplete
                        style="width:100%;"
                        v-model="rowData"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入内容"
                        @select="handleSelect"
                ></el-autocomplete>
            </div>

            <el-form :label-position="labelPosition" label-width="130px">
                <el-form-item label="中药汤方名：">
                    <template>
                        <el-select v-model="recipeName" placeholder="请选择中药汤方名">
                            <el-option
                                    v-for="item in cfName"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <el-form-item label="副数：">
                    <el-input-number type="number" :min="1" v-model="quantity"></el-input-number>
                </el-form-item>
                <el-form-item label="药袋价格：">
                    <!--<el-select v-model="drugPrice" placeholder="请选择" @change="medicine">
                        <el-option v-for="(item,index) in medicineBag" :key="index" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>-->
                    <el-dropdown @command="handleCommand">
                        <el-input v-model="drugPrice" placeholder="请输入或选择药袋价格"></el-input>
                        <el-dropdown-menu slot="dropdown">
                            <template v-for="(item,index) in medicineBag">
                                <el-dropdown-item :command="item.value">{{item.label}}</el-dropdown-item>
                            </template>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-form-item>
                <el-form-item label="煎服法：">
                    <el-input v-model="eatType" placeholder="请输入煎服法"></el-input>
                </el-form-item>
                <el-form-item label="忌口及日常护理：">
                    <el-input autosize type="textarea" placeholder="请输入忌口及日常护理" v-model="note"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="inOne-TabBttom">
            <el-button @click="handleSubmit()" type="primary">
                <i class="fa fa-floppy-o"></i>保存
            </el-button>
            <el-button @click="handleReset()" type="danger">
                <i class="fa fa-pencil" aria-hidden="true"></i>重置
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Aindex: '',
                OB: '',
                valueCf: '',     // 中药汤方名
                cfName: [      //中药汤方名
                    {
                        value: '中药汤方一',
                        label: '中药汤方一'
                    }, {
                        value: '中药汤方二',
                        label: '中药汤方二'
                    }, {
                        value: '茶方',
                        label: '茶方'
                    },
                    {
                        value: '医嘱',
                        label: '医嘱'
                    }
                ],
                indexV: 0,     // 表单下拉选择框
                foldData: [],
                repetitionId: 0, // 第二次提交保存id
                uData: null, // 用户数据对象
                coefficient: 0, // 系数
                eatType: "", // 煎服法
                note: "", //忌口及日常护理
                quantity: 0, // 副数
                medicineBag: [
                    {
                        value: 14,
                        label: '￥14'
                    }, {
                        value: 22,
                        label: '￥22'
                    }, {
                        value: 10,
                        label: '￥10'
                    }
                ],   // 药袋
                drugPrice:"",  // 药袋价格
                recipeName: '',    // 中药汤方名称
                recipeItemList: [],
                rowData: "", //  搜索行数据
                rowDatas: "",
                medicalRecipe: [], //  组方数据
                decimals: 1,
                labelPosition: "left",
                methodSelect: "", //煎服法：
                val: "",
                tableData: [],
                noncorresponding: {
                    input: ""
                },
                inx: 0,
                restaurants: [],//  添加新列 - 数据
                recipeItemId: 0,
                thIndex: 0,
                val2: '',
                cfArr: [],       // 替换汤方数据
                dialogFormVisible: false,
            };
        },
        props: ['priceSwitchVal'],
        methods: {
            handleCommand(command) {
                this.drugPrice = command;
            },
            select_Variation() {
                let tid = this.val;   //替换药品的id
                let cfArr = this.cfArr; //可替换的药品集
                let tindex = this.thIndex;
                let cObj;
                for (let i = 0; i < cfArr.length; i++) {
                    if (cfArr[i].id == tid) {
                        cObj = cfArr[i];
                        cObj.recordNumber = cfArr[i].recordNumber;
                        cObj.number = 0;
                        cObj.recipeItemId = this.recipeItemId;
                        cObj.medicineId = cfArr[i].id;
                    }
                }
                this.OB = cObj;
            },
            sure: function () {
                this.tableData.splice(this.thIndex, 1, this.OB);
                this.dialogFormVisible = false;
                this.OB = '';
                this.thIndex = 0;
            },

            substitute(index, row, indx) {  //替换
                let rowId = 0;
                this.recipeItemId = row.recipeItemId;
                if (row.id == undefined) {
                    rowId = row.medicineId;
                } else {
                    rowId = row.id;
                }
                this.thIndex = index;
                let that = this;
                that
                    .$axios({
                        url: "/api/medicines/relations/" + rowId,
                        method: "GET"
                    })
                    .then(res => {
                        if (res.data.data.length == 0) {
                            this.dialogFormVisible = false;
                            this.cfArr = [];
                            this.val = '';
                            that.$message({
                                message: '没有可替换的数据',
                                type: 'warning'
                            });
                        } else {
                            this.dialogFormVisible = true;
                            this.cfArr = res.data.data;
                            this.val = '';
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getZoneLists(index) {
                this.indexV = index;
            },
            drugSelect(val) {
                let that = this;
                let inx = this.indexV;
                that.foldData[inx].bagsCost = val
            },
            medicine(val) {
                this.drugPrice = val;
            },
            prescription() {
                let that = this;
                that
                    .$axios({
                        url: "/api/inquiry/recipes/" + that.uData.reservationId,
                        method: "GET"
                    })
                    .then(res => {
                        let allArr = res.data.data;
                        that.foldData = allArr;
                    })
                    .catch(err => {
                        console.log(err.data);
                    });
            },

            //汤方下保存
            preserveRemind(inx) {
                let that = this;
                let thatData = that.foldData[inx];
                let recipeItemResponses = thatData.recipeItemResponses
                for (let i = 0; i < recipeItemResponses.length; i++) {
                    if (recipeItemResponses[i].number == 0) {
                        that.$message({
                            type: "warning",
                            message: "请检查药品数量，序号：" + (i + 1)
                        });
                        return;
                    }
                }
                let pair = thatData.quantity;
                for (let j = 0; j < recipeItemResponses.length; j++) {
                    let opportunity = pair * recipeItemResponses[j].number;     // 数量 乘机结果
                    let inventory = recipeItemResponses[j].recordNumber;    // 库存数量
                    let consequence = inventory - opportunity;
                    if (consequence < 0) {
                        that.$message({
                            type: "error",
                            message: "您的库存不足无法保存! 序号: " + (j + 1)
                        });
                        return;
                    }
                }
                that
                    .$confirm("确认保存吗？", "提示", {})
                    .then(() => {
                        that
                            .$axios({
                                url: "/api/inquiry/recipe/" + that.foldData[inx].recipeId,
                                method: "PUT",
                                data: {
                                    bagsCost: thatData.bagsCost,//药袋价格
                                    coefficient: thatData.coefficient, //系数
                                    eatType: thatData.eatType, // 煎服法
                                    note: thatData.note, //忌口及日常护理
                                    quantity: thatData.quantity, // 副数
                                    recipeItemList: thatData.recipeItemResponses,
                                    recipeName: thatData.recipeName
                                }
                            })
                            .then(res => {
                                if (res.data.code == 200) {
                                    that.$message({
                                        type: "success",
                                        message: "保存成功"
                                    });
                                } else {
                                    that.$message({
                                        type: "error",
                                        message: "保存失败"
                                    });
                                }
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    })
                    .catch(err => {
                        that.$message({
                            type: "info",
                            message: "已取消保存"
                        });
                    });
            },

            numberchangeAccordion(val, index, inx) {
                this.foldData[inx].recipeItemResponses[index].number = val;
            },
            numberchange(val, index) {
                //  修改当前点击行 number
                this.recipeItemList[index].number = val;
            },
            makeUp() {
                //  组方数据
                this.$axios({
                    url: "/api/zufangs",
                    method: "GET"
                })
                    .then(res => {
                        this.medicalRecipe = res.data.data;
                    })
                    .catch(err => {
                        console.log(err.data);
                    });
            },
            newlyGain() {
                //  获取新增列 - 数据
                this.$axios({
                    url: "/api/medicines",
                    method: "GET"
                })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.restaurants = res.data.data;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            querySearchAsync(queryString, cb) {
                //  点击新增选择框
                var restaurants = this.restaurants;
                var results = queryString
                    ? restaurants.filter(this.createStateFilter(queryString))
                    : restaurants;
                if (results.length == 0) {
                    this.newlyGain(); //  获取 新增 行数据
                    return;
                }
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    cb(results);
                }, 1000 * Math.random());
            },
            location(index) {
                this.inx = index;
            },
            handleSelects(item) {
                let inx = this.inx;
                let _data = {
                    value: item.value, // 药品名称
                    number: 0, // 数量
                    recordNumber: item.recordNumber, // 库存数量
                    inventoryWarning: item.inventoryWarning,//库存预警
                    retailPrice: item.retailPrice, // 单价
                    unit: item.unit, // 单位
                    id: item.id,
                    medicineId: item.id,
                    repetition: false
                };
                this.rowDatas = "";
                let recipeItem = this.foldData[inx].recipeItemResponses;
                for (let i = 0; i < recipeItem.length; i++) {
                    // 判断是否id重复
                    if (recipeItem[i].medicineId == _data.id) {
                        // recipeItem[i].repetition = true;
//            this.tableData[i].repetition = true;
                        this.$message({
                            type: "error",
                            message: "药品已存在，请确认！序号:" + (i + 1)
                        });
                        return;
                    }
                }
                this.foldData[inx].recipeItemResponses.push(_data);

                // this.recipeItemList.push(postData);
            },

            handleSelect(item) {
                let tableData = []; // 重复数据
                let postData = {
                    medicineId: item.id,
                    number: 0
                };
                let _data = {
                    value: item.value, // 药品名称
                    number: 0, // 数量
                    recordNumber: item.recordNumber, // 库存数量
                    retailPrice: item.retailPrice, // 单价
                    unit: item.unit, // 单位
                    id: item.id,
                    medicineId: item.id,
                    inventoryWarning: item.inventoryWarning,
                    repetition: false
                };
                this.rowData = "";
                for (let i = 0; i < this.tableData.length; i++) {
                    // 判断是否id重复

                    if (this.tableData[i].medicineId == _data.medicineId) {
//          this.tableData[i].repetition = true;
                        this.$message({
                            type: "error",
                            message: "药品已存在，请确认！序号:" + (i + 1)
                        });
                        return;
                    }

                }
                this.recipeItemList.push(postData);
                this.tableData.push(_data);
            },
            createStateFilter(queryString) {
                //  element-ui api生成数据接口
                return state => {
                    return (
                        state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
                    );
                };
            },
            handleSubmit() {
                //新增界面里的确定提交按钮
                let that = this;
                let pair = that.quantity;       //副数

                if (that.recipeName == '') {
                    that.$message({
                        type: "warning",
                        message: "请选择汤方名"
                    });
                    return;
                }
                for (let i = 0; i < that.recipeItemList.length; i++) {
                    if (that.recipeItemList[i].number == 0) {
                        that.$message({
                            type: "warning",
                            message: "请检查药品数量, 序号: " + (i + 1)
                        });
                        return;
                    }

                    if (that.tableData[i].repetition) {
                        that.$message({
                            type: "warning",
                            message: "药品有重复，序号: " + (i + 1)
                        });
                        return;
                    }
                }
                for (let j = 0; j < that.tableData.length; j++) {
                    let opportunity = pair * that.tableData[j].number;     // 数量 乘机结果
                    let inventory = that.tableData[j].recordNumber;    // 库存数量
                    let consequence = inventory - opportunity;
                    if (consequence < 0) {
                        that.$message({
                            type: "error",
                            message: "您的库存不足无法保存! 序号: " + (j + 1)
                        });
                        return;
                    }
                }
                if (that.quantity >= 1 && that.quantity % 1 === 0) {
                    let Arr = [];
                    for (let k = 0; k < that.tableData.length; k++) {
                        let boj = {
                            number: Number(that.tableData[k].number),
                            medicineId: that.tableData[k].medicineId
                        }
                        Arr.push(boj)
                    }
                    that
                        .$confirm("确认保存吗？", "提示", {})
                        .then(() => {
                            that
                                .$axios({
                                    url: "/api/inquiry/recipe/" + that.uData.reservationId,
                                    method: "POST",
                                    data: {
                                        bagsCost: that.drugPrice,
                                        coefficient: that.coefficient, // 系数
                                        eatType: that.eatType, // 煎服法
                                        note: that.note, //忌口及日常护理
                                        quantity: that.quantity, // 副数
                                        recipeItemList: Arr, //所有药id和数量
                                        recipeName: that.recipeName  //汤方名
                                    }
                                })
                                .then(res => {
                                    if (res.data.code == 200) {
                                        that.$message({
                                            type: "success",
                                            message: "保存成功"
                                        });
                                        that.prescription();        // 刷新中药汤方
                                        that.noncorresponding.input = '';
                                        that.tableData = [];
                                        that.coefficient = 0;
                                        that.eatType = "";
                                        that.note = "";
                                        that.quantity = 0;
                                        that.recipeItemList = [];
                                        that.drugPrice = "";
                                        that.recipeName = '';
                                    } else {
                                        that.$message({
                                            type: "error",
                                            message: "保存失败"
                                        });
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        })
                        .catch(() => {
                            that.$message({
                                type: "info",
                                message: "已取消保存"
                            });
                        });
                } else {
                    this.$alert("请检查副数");
                }
            },
            handleReset() {
                //新增界面里的重置按钮
                let that = this;
                that
                    .$confirm("确认重置吗？", "提示", {})
                    .then(() => {
                        that.noncorresponding.input = '';
                        that.tableData = [];
                        that.coefficient = 0;
                        that.eatType = "";
                        that.note = "";
                        that.quantity = 0;
                        that.recipeItemList = [];
                        that.drugPrice = "";
                        that.recipeName = '';
                        that.$message({
                            type: "success",
                            message: "已重置了哟"
                        });
                    })
                    .catch(() => {
                        that.$message({
                            type: "info",
                            message: "已取消重置"
                        });
                    });
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
                this.recipeItemList.splice(index, 1);
            },
            deleteRows(index, rows, inx) {
               // rows.splice(index, 1);
                this.foldData[inx].recipeItemResponses.splice(index, 1);
            },
            selectVariation(vId) {
                //  组方 选中项id
                let obj = {};
                obj = this.medicalRecipe.find(item => {
                    //  点击组方 过滤获取id
                    return item.zufangLogo === vId;
                });
                if (obj.id != "") {
                    let tableData = [];
                    let tabData = []; // 重复数
                    tableData = this.tableData;
                    this.$axios({
                        url: "/api/zufangs/getOneZufang/" + obj.id,
                        method: "GET"
                    })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.recipeItemList = [];
                                let resData = res.data.data;
                                tableData = tableData.concat(resData.zufangItems);
                                for (let i = 0; i < tableData.length; i++) {
                                    // 判断是否id重复
                                    if (tabData.indexOf(tableData[i].medicineId) == -1) {
                                        tabData.push(tableData[i].medicineId);
                                        tableData[i].repetition = false;
                                    } else {
                                        tableData[i].repetition = true;
                                    }
                                }
                                this.tableData = tableData;
                                for (let i = 0; i < tableData.length; i++) {
                                    let postData = {};
                                    postData.medicineId = tableData[i].medicineId;
                                    postData.number = tableData[i].number;
                                    this.recipeItemList.push(postData);
                                }
                            }
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
            },
            getData(o) {
                let that = this;
                that.uData = o;
                that.prescription();
            },
            tableRowClassName({row, rowIndex}) {
                if (row.recordNumber <= row.inventoryWarning) {
                    return "warning-row";
                }
                return "";
            }
        },
        mounted() {
            this.newlyGain(); //  新增 行-数据
            this.makeUp(); //  组方数据
        }
    };
</script>

<style>
    @import "../../common/button.css";

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .inOne-advice {
        margin: 0 0 20px 0;
    }

    .titleText {
        display: inline-block;
        margin-right: 10px;
    }

    .titleText:not(:first-child) {
        margin-left: 20px;
    }

    .btn {
        margin-top: 15px;
        margin-bottom: 35px;
    }

    .add {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .inOne-TabBttom {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// inquiryAdvices.vue?5ed6efb6